<div>
  <div>
    <a href="#"
       (click)="$event.preventDefault(); handleSelectMore()"
       [class.disable-link]="disabled"
    >
      {{ selectedOptions.length ? selectMoreMessage : selectMessage }}
    </a>
  </div>
  <div>
    <div *ngIf="selectedOptions.length === 0">
      <span class="empty-message" [class.field-is-disabled]="disabled">No selection yet</span>
    </div>
    <div *ngFor="let option of selectedOptions" class="option-container">
      <div class="option-content" [class.field-is-disabled]="disabled">
        <div>{{ option.text }}</div>
<!--        <div *ngIf="option.originalData" class="description">{{ option.originalData.description }}</div>-->
      </div>
      <div
        class="option-delete-icon"
        [class.disable-unselect-option]="disabled"
        (click)="handleUnselectOption(option.value)"
      >
      </div>
    </div>
  </div>
  <div class="py-3 error-message" *ngIf="touched && selectionLimitErrorMessage">
    {{ selectionLimitErrorMessage }}
  </div>
</div>
